import { h } from 'preact';
import MenuBanner from './menu-banner';
import MenuList from './menu-list';
import MenuCards from './menu-cards';

const MenuItem = ({
  banner,
  navs,
  stories,
  view_all: viewAll,
  view_all_url: viewAllUrl,
  ...props
}) => {
  if (stories.length) {
    return (
      <div {...props}>
        <div className="max-w-container mx-auto px-10">
          <MenuCards
            items={stories}
            viewAll={viewAll}
            viewAllUrl={viewAllUrl}
          />
        </div>
      </div>
    );
  }

  return (
    <div {...props}>
      <div className="max-w-container mx-auto flex-col-reverse flex items-start tablet:flex-row !text-black">
        <MenuBanner {...banner} />
        <div className="flex-1 w-full tablet:py-20 lg:py-40 tablet:px-20 lg:px-40 tablet:grid grid-cols-4">
          {[...navs].slice(0, 4).map((item) => (
            <MenuList key={item.id} {...item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuItem;
